import { INVALID_MFA } from '../utils/sca-errors';
import type { ErrorObject } from '../utils/sca-errors';
import { MFA_STATUSES } from '../components/flows/mfa-modal';
import type { MfaStatus } from '../components/flows/mfa-modal';
import type { UserData } from '../providers/user-provider';

export function getInitialMfaStatus(errorDetails: ErrorObject, user: UserData): MfaStatus {
  if (errorDetails.code === INVALID_MFA) {
    return MFA_STATUSES.FAILURE;
  }

  if (
    errorDetails.mfaMethod === 'by_sms' ||
    errorDetails.mfaMethod === 'by_email' ||
    errorDetails.mfaMethod === 'by_app' ||
    user.mfaEnabled
  ) {
    return MFA_STATUSES.CONFIRMATION;
  }

  return MFA_STATUSES.NOT_STARTED;
}
